import {PinProtect} from '~/features/Auth/PinProtect';
import {RewardCodeLookup} from '~/features/LunaClub/RewardCodeLookup';

export const RewardCodeLookupScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <RewardCodeLookup />
      </PinProtect>
    </div>
  );
};
